import { WithAuditDetails } from 'data/types';
import { CollectionFunction } from 'data/collectionFunction/collectionFunction.types';
import {
  XtpXdpConnection, XtpXdpConnectionProtocol,
} from './xtp-xdp-connection.types'

export function adaptXtpXdpConnectionList(data: XtpXdpConnectionProtocol[]): XtpXdpConnectionProtocol[] {
  if (!data?.length) {
    return [];
  }

  return data.map((item) => ({
    ...item,
    name: item.cfid
  }));
}

export function adaptToCreate(
  xdpData: XtpXdpConnection,
): XtpXdpConnection {
  return xdpData;
}

export function getCretaredCfId(response: any): string {
  return window.atob(response?.action?.payload?.data?.metadata?.idCreated) || '';
}

export const adaptConnectionCfId = (
  body: WithAuditDetails<XtpXdpConnectionProtocol>,
  cfid: string
): WithAuditDetails<XtpXdpConnectionProtocol> => {

  return {
    ...body,
    data: {
      ...body.data,
      cfid
    }
  }
}

export function adaptToEdit(
  cf: CollectionFunction,
  entries: XtpXdpConnectionProtocol[],
  selected: XtpXdpConnectionProtocol[],
): XtpXdpConnection {
  const protocol = selected?.[0];
  const cfid = protocol?.cfid;
  const protocols = entries
    .filter((item) => item.cfid === cfid)
    .reduce((total, actual) => ({
      ...total,
      [actual.type]: actual
    }), {});

  const id = cf && cf.id ? cf.id : cfid

  return {
    id,
    name: cf?.name,
    type: cf?.type,
    cfid: id,
    ipduid: protocol?.ipduid || '',
    lbid: protocol?.lbid || '',
    destIp: protocol?.destIp || '',
    protocols,
  };
}
